import { clusters } from '../data/clusters.const'

class Sidebar {
    global = {
        cluster: 'cluster_1',
        holiday: false,
        title: ''
    }

    lesson = {
        type: {},
        start: {}
    }

    color = {
        background: '#1CA085',
        text: '#222F3D'
    }

    clusters = clusters

    reset() {
        this.global.holiday = false;
        this.global.title = '';
        this.color.background = '';
        this.color.text = '';
    }
}

export default new Sidebar();